import { render } from "./FolderPicker.vue?vue&type=template&id=8bcc5a7c"
import script from "./FolderPicker.vue?vue&type=script&lang=js"
export * from "./FolderPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__